module.exports = __webpack_public_path__ + "img/15674258757059uqh2m.370ddd86.png";